import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: false,
  tabs: {},
  error: "",
};

export const getTabs = createAsyncThunk("tab/getTabs", async (_, thunkApi) => {
  const { rejectWithValue, dispatch } = thunkApi;
  try {
    const res = await axios.get("/setting/api/v1/tab-settings/");
    // const data = res.data.results.map((tab) => ({
    //   id: tab.id,
    //   title: tab.title,
    //   link:tab.link,
    //   product: tab.product
    // }));
    return res.data;
  } catch (error) {
    if (error.response.statusCode === 401) {
      dispatch("admin/refresh");
    }
    return rejectWithValue(error.message);
  }
});

const tabSlice = createSlice({
  name: "tab",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTabs.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getTabs.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.tabs = action.payload;
    });
    builder.addCase(getTabs.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// export const { setSelectedCategories } = categorySlice.actions;
export default tabSlice.reducer;
